import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=2cdf8340&"
import script from "@/scripts/users/usersList.js?vue&type=script&lang=js&"
export * from "@/scripts/users/usersList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports